import React, {Component} from "react"
import PropTypes from "prop-types"

import {Form} from "~/components/"

export default class ApiForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: true,
      data: false
    }
  }

  componentDidMount() {
    if (this.props.id) {
      this.props.for
        .find(this.props.id)
        .then(data =>
          this.setState({
            loading: false,
            data: this.props.transformInitialState
              ? this.props.transformInitialState(data)
              : data
          })
        )
        .catch(err => console.log("Error loading data: " + err))
    } else {
      this.setState({loading: false})
    }
  }

  submit(params) {
    let _this = this,
      promise
    let _params = {}
    let entity_name = this.props.for.name.toLowerCase()
    _params[entity_name] = Object.assign(params, this.props.hiddenValues)

    if (this.state.data) {
      promise = _this.props.for.update(this.props.id, _params)
    } else {
      promise = _this.props.for.create(_params)
    }

    return new Promise(function(resolve, reject) {
      promise.then(() => resolve()).catch(err => reject(err))
    })
  }

  render() {
    if (this.state.loading) {
      return <p>Loading…</p>
    } else {
      return (
        <Form
          onSubmit={this.submit.bind(this)}
          then={this.props.then}
          submitLabel={this.props.submitLabel || "Save " + this.props.for.name}
          values={this.state.data}
        >
          {this.props.children}
        </Form>
      )
    }
  }
}

ApiForm.propTypes = {
  id: PropTypes.string,
  for: PropTypes.object.isRequired,
  transformInitialState: PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/forms/ApiForm.js